<template>
  <div class="contenBox" v-if="currentData.IS_SHOW==1">
    <ul style="height: 36px;width:876px;background-color: #D8D2CD;padding-top: 4px;padding-left: 4px;">
      <!--<li :class="currentIndex===1?'active':'noactive'" @click="handelNav(1)">-->
        <!--书页-->
      <!--</li>-->
      <li v-if="currentData.IS_SHOW==1" :class="currentIndex===0?'active':'noactive'" @click="handelNav(0)">
        介绍
      </li>
    </ul>
    <div style="overflow: hidden;width: 100%;">
      <div v-show="currentIndex===0" class="dataList1">
        <div style="font-size: 18px;color: #333333">
          {{ currentData.HTML_NAME }}
        </div>
        <p style="margin-top: 18px;">
          <span style="color: #999999;font-size: 13px;">{{ listData.CREATE_DATE }}</span>
          <span style="color: #999999;font-size: 13px;margin-left: 16px;">彭祖世家网</span>
          <span style="color: #999999;font-size: 13px;margin-left: 16px;">{{ listData.USER_NAME }}</span>
          <span v-if="listData.SHOW_ABSTRACT" class="ab_span" style="display: inline-block;background-color:#F8F8F8;color: #666666;width:810px;padding: 15px 5px;margin: 20px 0">{{ listData.SHOW_ABSTRACT }}</span>
          <span style="display: block" v-html="listData.SHOW_TEXT" />
        </p>
      </div>
      <div v-show="currentIndex===1" class="dataList1">
        <span v-html="listData.HTML_CONTENT" class="imgs_content"/>
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  components: { },
  props: ['listData', 'currentData'],
  inject: ['reload'],
  data() {
    return {
      currentPage1: 1,
      currentIndex: 0,
      peng1: require('@/static/pushuimg1.png'),
      shuyeData: [],
      params1: {
        index: 1,
        size: 10,
        // bookId: this.$route.query.sourceId
        nodeId: this.$route.query.sourceId
      }
    }
  },
  mounted() {

  },
  methods: {
    handelNav(index) {
      this.currentIndex = index
      // if (index === 1) {
      //   this.params1.index = 1
      //   this.fetchData('/portalArticle/getArticlePage', this.params1, 1)
      // }
    },
    handleSizeChange1(size) {
      this.params1.size = size
      this.fetchData('/portalArticle/getArticlePage', this.params1, 1)
    },
    handleCurrentChange1(page) {
      this.params1.index = page
      this.fetchData('/portalArticle/getArticlePage', this.params1, 1)
    },
    fetchData(url, params, index) {
      request({
        url: url,
        method: 'post',
        params: params
      }).then(res => {
        if (index === 1) {
          this.shuyeData = res.data
        }
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .contenBox{
    background-color: #fff;
    width: 880px;
    overflow: hidden;
    .active{
      background-color: #fff;
      font-size: 16px;
      display: inline-block;
      padding: 0 20px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      cursor: pointer;
    }
    .noactive{
      background-color: #D8D2CD;
      font-size: 16px;
      display: inline-block;
      padding: 0 20px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      cursor: pointer;
    }
    .dataList1{
      padding: 30px;
      .hasImg{
        display: inline-block;width: 600px;
        overflow: hidden;
        height: 100px;
        padding-left: 20px;
        vertical-align: top;
        .content_cext{
          line-height: 20px;
          margin-top: 20px;
          display: inline-block;
          overflow: hidden;
          font-size: 12px;
          color: #666666;
          text-overflow:ellipsis;
          display:-webkit-box;
          -webkit-box-orient:vertical;
          -webkit-line-clamp:3;
        }
      }
      .noImg{
        display: inline-block;width: 820px;
        overflow: hidden;
        height: 100px;
        vertical-align: top;
        .content_cext{
          margin-top: 20px;
          display: inline-block;
          overflow: hidden;
          font-size: 12px;
          line-height: 20px;
          color: #666666;
          text-overflow:ellipsis;
          display:-webkit-box;
          -webkit-box-orient:vertical;
          -webkit-line-clamp:3;
        }
      }
    }
  }
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .contenBox{
      width: 100%!important;
      ul{
        width: 100%!important;
        white-space: nowrap;
        overflow-x: auto;
        li{
          width: 60px;
        }
        .noactive{
          width: 60px;
        }
        .active{
          width: 60px;
        }
      }
      .ab_span{
        width: 100%!important;
      }
      .noImg{
        width: 100%!important;
      }
      .pagina_box{
        white-space: nowrap;
        overflow-x: auto;
      }
    }
  }
</style>

